import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { useNavigate, useLocation } from '@thd-olt-component-react/router';
import { generateImageSource } from '../../../utils/generateImageSource';
import { useStore } from '../../../store';
import { EXP_ROUTES } from '../../../utils/constants';
import { jobPostingValidators } from '../../../utils/validations';

export const CompanyProfileButtons = ({ update, profile }) => {

  const {
    companyProfileStore: {
      submitCompanyProfile,
      showSubmitErrorNotification
    }
  } = useStore();

  const navigate = useNavigate();
  const location = useLocation();
  const showSkip = location?.state?.jobPostings;

  const submitClick = () => {
    update();
    if (!jobPostingValidators.companyUrl({ companyUrl: profile.url })) {
      showSubmitErrorNotification();
    } else {
      submitCompanyProfile();
      navigate(EXP_ROUTES.JOB_POSTINGS);
    }
  };

  return (
    <div className="ptp-company-profile__button-container">
      <Button
        className="cancel-button"
        data-testid="cancel-company-profile"
        onClick={() => {
          navigate(EXP_ROUTES.JOB_POSTINGS);
        }}
        style={{
          fontWeight: '600',
          fontSize: '16px',
          width: '55px'
        }}
        link
      >
        Cancel
      </Button>
      {showSkip && (
        <Button
          className="skip-step-button"
          data-testid="skip-company-profile"
          outline
          onClick={() => {
            navigate(EXP_ROUTES.CREATE_JOB_POSTING);
          }}
          style={{
            fontWeight: '600',
            fontSize: '16px',
            width: '175px'
          }}
        >
          Skip this Step
          <img
            className="ptp-company-profile__chevron"
            src={generateImageSource('/images/v1/caret-orange.svg')}
          />
        </Button>
      )}
      <Button
        data-testid="submit-company-profile"
        style={{
          fontWeight: '600',
          fontSize: '16px',
          width: '175px'
        }}
        onClick={submitClick}
        disabled={!profile.description?.trim() && !profile.url?.trim()}
      >
        Submit
      </Button>
    </div>
  );
};
